import { NgModule } from '@angular/core';
import { provideApollo, provideClientMap } from './Apollo';
import { SelectPipe } from './SelectPipe';
export var APOLLO_DIRECTIVES = [
    SelectPipe,
];
export var APOLLO_PROVIDERS = [
    provideApollo,
];
export function defaultApolloClient(clientFn) {
    return provideClientMap(clientFn);
}
var ApolloModule = (function () {
    function ApolloModule() {
    }
    // XXX: Keep it to avoid a breaking change
    ApolloModule.withClient = function (clientFn) {
        return {
            ngModule: ApolloModule,
            providers: [
                APOLLO_PROVIDERS,
                defaultApolloClient(clientFn),
            ],
        };
    };
    /**
     * Defines a map of ApolloClients or a single instance
     */
    ApolloModule.forRoot = function (clientMapFn) {
        return {
            ngModule: ApolloModule,
            providers: [
                APOLLO_PROVIDERS,
                provideClientMap(clientMapFn),
            ],
        };
    };
    ApolloModule.decorators = [
        { type: NgModule, args: [{
                    declarations: APOLLO_DIRECTIVES,
                    exports: APOLLO_DIRECTIVES,
                },] },
    ];
    /** @nocollapse */
    ApolloModule.ctorParameters = function () { return []; };
    return ApolloModule;
}());
export { ApolloModule };
//# sourceMappingURL=ApolloModule.js.map


//////////////////
// WEBPACK FOOTER
// ./~/apollo-angular/build/src/ApolloModule.js
// module id = 675
// module chunks = 9